// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"77cec4be","498":"ebd2702b","703":"cd15995d","787":"5498dab1"}[chunkId] + ".chunk.js";
};